export default __webpack_public_path__ + "static/media/cabinet1-before-768w.da71efed.avif";